"use client";

import { usePathname, useRouter } from "next/navigation";
import { parseAsBoolean, useQueryState } from "nuqs";
import { useCallback, useEffect, useState } from "react";

export default function useParamToggler(param = "openSector") {
  const router = useRouter();
  const pathname = usePathname() ?? "";
  const [isOpen, setIsOpen] = useState(false);
  const [queryValue, setQueryValue] = useQueryState(param, parseAsBoolean);

  useEffect(() => {
    setIsOpen(Boolean(queryValue));
  }, [queryValue]);

  const openModal = () => {
    setIsOpen(true);
    setQueryValue(true, { shallow: true });
  };

  const closeModal = () => {
    setIsOpen(false);
    setQueryValue(null, { shallow: true }); // removes the param
  };

  const toggleModal = () => (isOpen ? closeModal() : openModal());

  const appendQueryParameter = useCallback(
    (key: string, value: string) => {
      setQueryValue((prev) => prev ?? value === "true", { shallow: true });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname, router, setQueryValue],
  );

  const removeQueryParameter = useCallback(() => {
    setQueryValue(null, { shallow: true });
  }, [setQueryValue]);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
    appendQueryParameter,
    removeQueryParameter,
  };
}
